import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomDropDown from '../../Components/Reusable/CustomDropDown';
import { handleApiErrors, InputType } from '../../Utils/Utils';
import { PngImages, SvgImages } from '../../Utils/LocalImages';
import { ConfirmationModalTheme, ImageFilters } from '../../Utils/Enums';
import ClassService from '../../Services/ClassService';
import SubjectService from '../../Services/SubjectService';
import DataProvider from '../../Utils/DataProvider';
import ReviewerService from '../../Services/ReviewerService';
import { FaCheck } from 'react-icons/fa6';
import parse from "html-react-parser";
import Image from '../../Components/Reusable/Image';
import SubmitButton from '../../Components/Reusable/Buttons';
import RoutesPath from '../../Utils/RoutesPath';
import ConfirmationModal from '../../Components/modal/ConfirmationModal';
import { toast } from 'react-toastify';
import { CirclesWithBar } from 'react-loader-spinner';
import { AuthContext } from '../../Context/authContext';


const ReviewerQuestionList = () => {
    const [data, setData] = useState([]);
    const location = useLocation();
    const { editedQuestion } = location.state || {}; // Get editedQuestion safely
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const [selectedSubjectFilter, setSelectedSubjectFilter] = useState("");
    const [resetSubject, setResetSubject] = useState(false);
    const [resetmedium, setResetMedium] = useState(false);
    const [selectedMedium, setSelectedMedium] = useState("");
    const [selectedClassFilter, setSelectedClassFilter] = useState(null);
    const [classes, setClasses] = useState([]);
    const [mediumList, setMediumList] = useState(DataProvider.mediumList);
    const [currentPage, setCurrentPage] = useState(0);
    const [showConfirmationModal, setShowConfirmationModal] = useState({
        show: false,
        questionId: null,
        status: null,
      });
    const { user } = useContext(AuthContext)
    const navigate = useNavigate();
    const getAllReviewerQuestionList = async () => {
        setLoading(true);
        try {
            const response = await ReviewerService.getAllReviewerQuestionList(
                selectedMedium || "",
                selectedClassFilter || "",
                selectedSubjectFilter || "",
            );
            if (Array.isArray(response.data)) {
                setData(response.data);
            } else {
                setData([]);
            }
        } catch (error) {
            handleApiErrors(error);
        } finally {
      setLoading(false);
    }
    };

    const getAllClasses = async () => {
        try {
          const response = await ClassService.getAllClassesWithoutPagination();
          setClasses(response.data);
        } catch (error) {
          handleApiErrors(error);
        }
      };

    useEffect(() => {
        getAllClasses()
    }, [])
    useEffect(() => {
        if (selectedClassFilter || classes.length > 0) {
            getAllSubjects(selectedClassFilter || classes[0]._id );
        } else {
            setSubjects([]);
        }
    }, [selectedClassFilter,classes]);

    const getAllSubjects = async (classId) => {
        try {
            const response = await SubjectService.getAllSubjectsWithoutPagination(classId);
            setSubjects(response.data);
           
            
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const customParser = (node) => {
        if (node.name === "oembed") {
            const url = node.attribs.url;
            let videoId;
            // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
            if (url.includes("youtube.com")) {
                videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
            } else if (url.includes("youtu.be")) {
                videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
            }
            if (videoId) {
                return (
                    <iframe
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="YouTube video"
                    />
                );
            } else {
                return <p className='text-danger'>Invalid YouTube URL</p>;
            }
        }
    };

    const cleanQuestionText = (text) => {
        return text.replace(/&nbsp;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const getAlphabetLabel = (index) => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        return letters[index] || "";
    };

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (
                selectedMedium != null ||
                selectedClassFilter != null ||
                selectedSubjectFilter != null
            ) {
                getAllReviewerQuestionList()
            }
        }, 500);
        return () => clearTimeout(timeOutId);
    }, [selectedMedium, selectedClassFilter, selectedSubjectFilter]);

    const handleToggleSolution = (index) => {
        // Toggle solution visibility
        setOpenIndex(openIndex === index ? null : index);
    };


    const nextPage = () => {
        if (currentPage < data.length - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    // Load the previous question
    const prevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };


    const reviewerupdateStatus = async (questionId, status) => {
        try {
          console.log("ID:", questionId); // Debug: Ensure `questionId` is correct
          console.log("Status:", status); // Debug: Ensure `status` is correct
      
          await ReviewerService.reviewerupdateStatus(questionId, status);
          toast.success("Question Status Updated successfully");
      
          // Update Local Data
          const updatedData = [...data];
          const index = updatedData.findIndex((item) => item.question_id === questionId);
          if (index !== -1) {
            updatedData[index].status = status;
          }
          setData(updatedData); // Ensure state is updated
        } catch (error) {
          console.error("Error updating item:", error);
          toast.error("Failed to update question status.");
        } finally {
          // Ensure modal closes in all cases
          setShowConfirmationModal({ show: false, questionId: null, status: null });
        }
      };



      useEffect(() => {
      
        if ((editedQuestion?.class_id && !selectedClassFilter) || 
            (editedQuestion?.subject_id && !selectedSubjectFilter)) {
          setSelectedClassFilter(editedQuestion.class_id);
          setSelectedSubjectFilter(editedQuestion.subject_id); // Set subject filter
          setSelectedMedium(editedQuestion.medium); // Set medium filter
        }
      }, [editedQuestion, selectedClassFilter, selectedSubjectFilter,selectedMedium]);
    
    
    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <h1 className="black fs-18 fw-600 text-capitalize mb-0">Question bank review</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">Question bank review</h4>
                </div>
            </div>
            <div className="table_container">
                <div className='d-flex justify-content-between'>
                    <h1 className="black fs-18 fw-600 mb-0">Question Paper</h1>
                </div>
                <div className="row profile_inputs w-100 gap-1  mt-3 Responsivesearchbars">
                <div className="col-md-10 col-lg-3 col-sm-12">
                {(editedQuestion || classes.length > 0) && classes.length > 0 && (
        <CustomDropDown
            placeholder="Class"
            name="class"
            id="class"
            Dropdownclass="marginsection"
            labelClass="commissionsection"
            onChange={(e) => {
                setSelectedSubjectFilter("");
                setResetSubject(true);
                setResetMedium(true);
                setSelectedClassFilter(e.value); 
                setCurrentPage(0);
            }}
            options={classes.map((e) => ({
                value: e._id,
                label: e.class_name,
            }))}
            defaultOption={{
                value: selectedClassFilter || editedQuestion?.class_id || null,
                label: (() => {
                    if (classes.length > 0) {
                        console.log('Looking for class with ID:', selectedClassFilter || editedQuestion?.class_id);

                        const selectedClass = classes.find(c => c._id === (selectedClassFilter || editedQuestion?.class_id));
                        console.log('Found class:', selectedClass); // Check if class is found
                        return selectedClass ? selectedClass.class_name : "Class"; 
                    } else {
                        return "Class";  // Fallback if classes are not loaded
                    }
                })()
            }}
        />
    )}
</div>

<div className="col-md-10 col-lg-3 col-sm-12">
{/* {subjects.length > 0 && ( */}
  <CustomDropDown
    placeholder="Subject"
    name="subject"
    id="subject"
    Dropdownclass="marginsection"
    labelClass="commissionsection"
    resetValue={resetSubject}
    setResetValue={setResetSubject}
    onChange={(e) => {
      setSelectedSubjectFilter(e.value);
      setCurrentPage(0);
    }}
    options={
        [{ value: "", label: "All" }, ...subjects.map((e) => { return { value: e._id, label: e.subject_name } }) ?? []]
      }
    defaultOption={{
      value: selectedSubjectFilter || editedQuestion?.subject_id || null,
      label: (() => {
        const subjectId = selectedSubjectFilter || editedQuestion?.subject_id;
        if (!subjectId) {
          console.log('No subjectId to look for');
          return "Subject"; // Fallback if no subjectId is available
        }

        const selectedSubject = subjects.find(c => c._id === subjectId);
        console.log("Found subject:", selectedSubject);

        if (selectedSubject) {
          return selectedSubject.subject_name;
        }

        console.log('Subject not found in array for ID:', subjectId);
        return "Subject"; 
      })()
    }}
  />
{/* )} */}

</div>


<div className="col-md-10 col-lg-3 col-sm-12">
<CustomDropDown
  placeholder="Medium"
  name="medium"
  id="medium"
  Dropdownclass="marginsection"
  labelClass="commissionsection"
  resetValue={resetmedium}
  setResetValue={setResetMedium}
  options={[
    { value: "", label: "All" },
    ...(mediumList ?? []),
  ]}
  onChange={(e) => {
    console.log("Medium Selected:", e.value); // Log selected medium
    setSelectedMedium(e.value);
    setCurrentPage(0);
  }}
  defaultOption={{
    value: selectedMedium || editedQuestion?.medium || "", // Ensure valid value
    label: (() => {
      if (selectedMedium) return selectedMedium; // Show selected medium
      if (editedQuestion?.medium) return editedQuestion.medium; // Show edited medium
      return "Medium"; // Fallback label
    })(),
  }}
/>

  </div>
                </div>
                <section className='small-medium-text fw-600 my-4'>
                {loading ? (
              <div className="text-center d-flex justify-content-center">
                <CirclesWithBar
                  height="80"
                  width="80"
                  color="#14489f"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
                <>
                    {data  && Array.isArray(data) && data.length > 0 ? (
                        <div>
                            {data.slice(currentPage, currentPage + 1).map((q, index) => (
                                <div key={index} className='my-4 border-question '>
                                    <div className="small-medium-text   fw-600 mb-3 d-flex justify-content-start text-center gap-1">
                                        Question {currentPage + 1}
                                        <div>
                                        </div>
                                    </div>
                                    {q.type_of_question === 'Comprehensive' || q.type_of_question === 'Poem' ? (
                                        <div>
                                            <div className='fs-14 fw-600 mb-2 pt-2 black border-question-top'>Read Carefully</div>
                                            {q?.type_of_question === 'Comprehensive' || q?.type_of_question === 'Poem' ? (


                                                <div className="fw-400  blog-data-html" style={{ contain: "content", width: '100%' }}>
                                                    {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                                </div>

                                            ) : (
                                                null
                                            )}
                                            {Array.isArray(q.subQuestions) &&
                                                q.subQuestions.map((subQ, subIndex) => (
                                                    <div key={subIndex} className='mt-4 mb-2'>

                                                        <div className=" d-flex justify-content-between">
                                                            <div className="d-flex gap-2 align-items-center">
                                                                <div className="small-medium-text fw-600 text-dark d-flex  align-items-center gap-2">

                                                                    <div style={{ marginBottom: '6px' }}>{subIndex + 1}.</div>
                                                                    {q?.type_of_question === 'Poem' || 'Comprehensive' ? (

                                                                        <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                            {cleanQuestionText(subQ?.question) && parse(cleanQuestionText(subQ.question), { replace: customParser })}
                                                                        </div>

                                                                    ) : (
                                                                        null
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <ol className="list-group mt-2 ">
                                                            {Array.isArray(subQ.options) &&
                                                                subQ.options.map((option, optIndex) => {
                                                                    const isUserSelected = subQ.selectedOption === optIndex;
                                                                    const isCorrectOption = subQ.correctOption === optIndex;
                                                                    return (
                                                                        <li
                                                                            key={optIndex}
                                                                            className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                                                            style={{
                                                                                color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                                                            }}
                                                                        >
                                                                            <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                                                                <div className="checkmarks"
                                                                                    style={{
                                                                                        border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                                                        backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                                                        marginBottom: "16px"
                                                                                    }}
                                                                                >
                                                                                    {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}</div>
                                                                                <label
                                                                                    className="form-check-label small-medium-text fw-400 px-2  "
                                                                                    htmlFor={`Comprehensive-option-${index}-${subIndex}`}
                                                                                >
                                                                                    <div className="d-flex gap-2">
                                                                                        <span>{getAlphabetLabel(optIndex)}. </span> <span>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</span>
                                                                                        <div className="text-end">
                                                                                            {isCorrectOption && !isUserSelected && (
                                                                                                <span className="fs-14 ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>

                                                                                </label>
                                                                            </div>
                                                                        </li>
                                                                    );
                                                                })}
                                                        </ol>
                                                        {subQ.solution !== "" ? (
                                                            <div className="d-flex gap-2 align-items-center mt-2">
                                                                <div className='d-flex gap-1 align-items-center cursor-pointer'
                                                                    onClick={() => handleToggleSolution(`${index}-${subIndex}`)}>
                                                                    {/* <Image src={PngImages.light_bulb} alt="Light Bulb Icon" /> */}
                                                                    <div>
                                                                        <h3 className="fs-16 fw-500 mb-0 orangeAsscent" style={{ textDecoration: 'underline' }}>  {openIndex === `${index}-${subIndex}` ? 'Solution' : 'Solution'}</h3>
                                                                    </div>
                                                                </div>
                                                            </div>) : null}
                                                        {openIndex === `${index}-${subIndex}` && (
                                                            <div className="mt-3" style={{ lineHeight: '24px' }}>
                                                                <div className="fs-16 fw-600">
                                                                    {subQ?.type_of_question === 'Poem' || 'Comprehensive' ? (

                                                                        <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                            {cleanQuestionText(subQ.solution) && parse(cleanQuestionText(subQ.solution), { replace: customParser })}
                                                                        </div>

                                                                    ) : (
                                                                        null
                                                                    )}
                                                                </div>

                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            <div className="d-flex gap_8 justify-content-end mb-4">
                                                <a
                                                   onClick={() => {

                                                    const reviewerPrivileage = user?.setPrivileges?.find(
                                                        (priv) => priv.parameter === "Reviewer"
                                                      );
                                                      if (!reviewerPrivileage?.update) {
                                                       
                                                        toast.warning(
                                                          "You don't have permission to edit question."
                                                        );
                                                        return;
                                                      }

                                                    navigate(RoutesPath.revieweraddquestionbank, {
                                                        state: q,
                                                    })
                                                }}
                                                    className="edit_icons_two cursor-pointer"
                                                    data-bs-target="#editclass"
                                                    data-bs-toggle="modal"
                                                >
                                                    <Image
                                                        src={SvgImages.edit}
                                                        style={ImageFilters.blue}
                                                        className="add_icons"
                                                        alt="Edit Icon"
                                                    />
                                                </a>
                                                <a
                                                 onClick={() => {
                                                
                                                    const reviewerPrivileage = user?.setPrivileges?.find(
                                                        (priv) => priv.parameter === "Reviewer"
                                                      );
                                                      if (!reviewerPrivileage?.update) {
                                                        
                                                        toast.warning(
                                                          "You don't have permission to update the status"
                                                        );
                                                        return;
                                                      }

                                                    setShowConfirmationModal({
                                                      show: true,
                                                      questionId: q.id,
                                                      status: "approved",
                                                    });
                                                  }}
                                                    className="edit_icons cursor-pointer"
                                                    data-bs-target="#editclass"
                                                    data-bs-toggle="modal"
                                                >
                                                    <Image
                                                        src={SvgImages.tick_mark}
                                                        style={ImageFilters.green}
                                                        className="add_icons"
                                                        alt="Edit Icon"
                                                    />
                                                </a>
                                                {/* <a
                                                 onClick={() =>{

                                                    const reviewerPrivileage = user?.setPrivileges?.find(
                                                        (priv) => priv.parameter === "Reviewer"
                                                      );
                                                      if (!reviewerPrivileage?.update) {
                                                      
                                                        toast.warning(
                                                          "You don't have permission to update the status"
                                                        );
                                                        return;
                                                      }

                                                    setShowConfirmationModal({
                                                        show: true,
                                                        questionId: q.id,
                                                        status: "rejected",
                                                      });
                                                }}
                                                    className="delete_icons cursor-pointer"
                                                >
                                                    <Image
                                                        src={SvgImages.cross}
                                                        style={ImageFilters.red}
                                                        data-bs-target="#delete-modal"
                                                        data-bs-toggle="modal"
                                                        alt="Delete Icon"
                                                    />
                                                </a> */}

                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="d-flex justify-content-between">
                                                {q?.type_of_question === 'General' ? (

                                                    <div className=" blog-data-html " style={{ contain: "content", width: '100%' }}>

                                                        {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                                    </div>

                                                ) : (
                                                    null
                                                )}
                                            </div>

                                            <ol className="list-group my-2">
                                                {Array.isArray(q.options) &&
                                                    q.options.map((option, optIndex) => {
                                                        const isUserSelected = q.selectedOption === optIndex;
                                                        const isCorrectOption = q.correctOption === optIndex;

                                                        return (
                                                            <li
                                                                key={optIndex}
                                                                className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                                                style={{
                                                                    color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                                                }}
                                                            >
                                                                <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                                                    <div className="checkmarks"
                                                                        style={{
                                                                            border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                                            backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                                            marginBottom: "16px"
                                                                        }}
                                                                    >
                                                                        {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                                                    <label
                                                                        className="form-check-label small-medium-text fw-500 px-2"
                                                                        htmlFor={`General-option-${index}-${optIndex}`}
                                                                    >
                                                                        <div className="d-flex gap-2 fw-400">
                                                                            <span >{getAlphabetLabel(optIndex)}. </span> <span><p>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</p></span>
                                                                            <div>
                                                                                {isCorrectOption && !isUserSelected && (
                                                                                    <span className="fs-14 ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                                                )}
                                                                                {/* {isUserSelected && !isCorrectOption && (
                                                                <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                                            )}
                                                            {isUserSelected && isCorrectOption && (
                                                                <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                                            )} */}
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                            </ol>
                                            {
                                                q.solution !== "" ? (
                                                    <div className="d-flex gap-2 align-items-center mt-2">
                                                        <div className='d-flex gap-1 align-items-center cursor-pointer'
                                                            onClick={() => handleToggleSolution(index)}>
                                                            {/* <Image src={PngImages.light_bulb} alt="Light Bulb Icon" /> */}
                                                            <div>
                                                                <h3 className="fs-16 fw-500 mb-0 orangeAsscent" style={{ textDecoration: 'underline' }}> {openIndex === index ? 'Solution' : 'Solution'}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            {openIndex === index && (

                                                // <div className="mt-3" style={{ lineHeight: '24px' }}>
                                                //     <div className="small-medium-text fw-600">{decodeHtml(q.solution?.replace(/&nbsp;/g, ' '))}</div>
                                                // </div>
                                                <div className="mt-3" style={{ lineHeight: '24px' }}>
                                                    <div className="fs-16 fw-600">
                                                        {q?.type_of_question === 'General' ? (

                                                            <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                {cleanQuestionText(q.solution) && parse(cleanQuestionText(q.solution), { replace: customParser })}
                                                            </div>

                                                        ) : (
                                                            null
                                                        )}
                                                    </div>


                                                </div>


                                            )}
                                            <div className="d-flex gap_8 justify-content-end mb-4">
                                                <a
                                                    onClick={() => {
                                                        
                                                    const reviewerPrivileage = user?.setPrivileges?.find(
                                                        (priv) => priv.parameter === "Reviewer"
                                                      );
                                                      if (!reviewerPrivileage?.update) {
                                                        toast.warning(
                                                          "You don't have permission to edit question."
                                                        );
                                                        return;
                                                      }
                                                        navigate(RoutesPath.revieweraddquestionbank, {
                                                            state: q,
                                                        })
                                                    }}
                                                    className="edit_icons_two cursor-pointer"
                                                // data-bs-target="#editclass"
                                                // data-bs-toggle="modal"
                                                >
                                                    <Image
                                                        src={SvgImages.edit}
                                                        style={ImageFilters.blue}
                                                        className="add_icons"
                                                        alt="Edit Icon"
                                                    />
                                                </a>
                                                <a
                                                   onClick={() => {
                                              const reviewerPrivileage = user?.setPrivileges?.find(
                                                        (priv) => priv.parameter === "Reviewer"
                                                      );
                                                      if (!reviewerPrivileage?.update) {
                                                        toast.warning(
                                                          "You don't have permission to update the status"
                                                        );
                                                        return;
                                                      }
                                                    setShowConfirmationModal({
                                                      show: true,
                                                      questionId: q.id,
                                                      status: "approved",
                                                    });
                                                  }}
                                                    className="edit_icons cursor-pointer"
                                                    data-bs-target="#editclass"
                                                    data-bs-toggle="modal"
                                                >
                                                    <Image
                                                        src={SvgImages.tick_mark}
                                                        style={ImageFilters.green}
                                                        className="add_icons"
                                                        alt="Edit Icon"
                                                    />
                                                </a>
                                                {/* <a
                                                    className="delete_icons cursor-pointer"
                                                    onClick={() => {
                                                        const reviewerPrivileage = user?.setPrivileges?.find(
                                                            (priv) => priv.parameter === "Reviewer"
                                                          );
                                                          if (!reviewerPrivileage?.update) {
                                                            toast.warning(
                                                              "You don't have permission to update the status"
                                                            );
                                                            return;
                                                          }
                                                        setShowConfirmationModal({
                                                          show: true,
                                                          questionId: q.id,
                                                          status: "rejected",
                                                        });
                                                      }}
                                                >
                                                    <Image
                                                        src={SvgImages.cross}
                                                        style={ImageFilters.red}
                                                        data-bs-target="#delete-modal"
                                                        data-bs-toggle="modal"
                                                        alt="Delete Icon"
                                                    />
                                                </a> */}

                                            </div>
                                        </div>

                                    )}

                                </div>

                            ))}

                            <div className="d-flex flex-wrap justify-content-between align-items-center fs-16 fw-400 px-2 gap-2">
                                <div className="d-flex gap-3">
                                    <SubmitButton
                                        title={'Previous'}
                                        className="previewbtn"
                                        onClick={prevPage} disabled={currentPage === 0}
                                    />
                                </div>

                                <div className="d-flex gap-3">
                                    <SubmitButton
                                        className="nextbtn"
                                        title={'Next'}
                                        onClick={nextPage} disabled={currentPage === data.length - 1}
                                    />
                                </div>
                            </div>

                        </div>

                    ) : (
                        <div className="d-flex flex-column align-items-center justify-content-center my-3 h-100">
                            <Image
                                src={PngImages.reviewerpopup}
                                style={{ height: 250 }}
                            />
                            {/* <h1 className="subText fs-20 fw-600 my-3 black">
                                No Questions Found
                            </h1> */}
                        </div>
                    )}
                    </>)}
                </section>
            </div>
            <ConfirmationModal
  showModal={showConfirmationModal.show}
  setShowModal={() =>
    setShowConfirmationModal({ show: false, questionId: null, status: null })
  }
  text={"Are you sure you want to update the status?"}
  icon={SvgImages.exclamation_mark}
  rightClickAction={() => {
    reviewerupdateStatus(
      showConfirmationModal.questionId, // Ensure this is defined
      showConfirmationModal.status
    );
  }}
  theme={ConfirmationModalTheme.warning}
/>
        </div>
    )
}

export default ReviewerQuestionList
